import { render, staticRenderFns } from "./UidTokenLoginPopup.vue?vue&type=template&id=4cbc9ffe&scoped=true&"
import script from "./UidTokenLoginPopup.vue?vue&type=script&lang=js&"
export * from "./UidTokenLoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenLoginPopup.vue?vue&type=style&index=0&id=4cbc9ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc9ffe",
  null
  
)

export default component.exports